<template>
  <div class="admin-shell">
    <div class="admin-shell__overlay" :class="{ 'is-open': navOpen }" @click="navOpen = false"></div>
    <aside class="admin-shell__aside" :class="{ 'is-open': navOpen }">
      <div class="admin-brand">
        <span class="admin-brand__mark">SY</span>
        <div>
          <strong>尚亚科技</strong>
          <small>CONTENT MANAGEMENT</small>
        </div>
        <button type="button" aria-label="关闭后台导航" @click="navOpen = false">×</button>
      </div>
      <el-menu :default-active="$route.path" class="admin-menu" router @select="navOpen = false">
        <el-menu-item v-for="item in navItems" :key="item.path" :index="item.path">
          <i :class="item.icon"></i>
          <span slot="title">{{ item.label }}</span>
        </el-menu-item>
      </el-menu>
      <div class="admin-aside__foot">
        <span>SHANGYA ADMIN</span>
        <small>网站内容管理系统</small>
      </div>
    </aside>

    <section class="admin-shell__main">
      <header class="admin-shell__header">
        <div class="admin-title">
          <button class="admin-nav-toggle" type="button" aria-label="打开后台导航" @click="navOpen = true">
            <i class="el-icon-menu"></i>
          </button>
          <div>
            <span>网站后台</span>
            <h1>{{ currentTitle }}</h1>
          </div>
        </div>
        <div class="admin-actions">
          <router-link class="admin-preview" to="/" target="_blank">
            <i class="el-icon-view"></i>
            预览网站
          </router-link>
          <button class="admin-logout" type="button" @click="logout">
            <i class="el-icon-switch-button"></i>
            退出登录
          </button>
        </div>
      </header>

      <main class="admin-shell__content">
        <router-view />
      </main>
      <footer class="admin-shell__footer">© {{ currentYear }} 尚亚科技 · 内容管理中心</footer>
    </section>
  </div>
</template>

<script>
export default {
  name: "admin",
  data() {
    return {
      navOpen: false,
      currentYear: new Date().getFullYear(),
      navItems: [
        { path: "/admin/site-config", label: "网站配置管理", icon: "el-icon-s-tools" },
        { path: "/admin/cases", label: "案例信息管理", icon: "el-icon-collection" },
        { path: "/admin/team", label: "团队风采管理", icon: "el-icon-picture-outline" },
        { path: "/admin/course", label: "发展历程管理", icon: "el-icon-time" },
        { path: "/admin/enterprise", label: "合作企业管理", icon: "el-icon-office-building" },
        { path: "/admin/honor", label: "荣誉墙管理", icon: "el-icon-trophy" },
        { path: "/admin/investment", label: "招商图片管理", icon: "el-icon-files" },
        { path: "/admin/dictionary", label: "数据字典管理", icon: "el-icon-setting" }
      ]
    };
  },
  computed: {
    currentTitle() {
      const current = this.navItems.find(item => item.path === this.$route.path);
      return current ? current.label : "管理中心";
    }
  },
  methods: {
    logout() {
      sessionStorage.removeItem("token");
      this.$message.success("已安全退出");
      this.$router.replace("/login");
    }
  }
};
</script>

<style lang="scss">
.site-main--admin {
  min-height: 100vh;
  background: #eef4f7;
}

.admin-shell {
  display: flex;
  min-height: 100vh;
  color: var(--ink-800);
  background: #eef4f7;
}

.admin-shell__aside {
  position: fixed;
  inset: 0 auto 0 0;
  z-index: 100;
  display: flex;
  width: 248px;
  flex-direction: column;
  overflow: hidden;
  color: #fff;
  background:
    radial-gradient(circle at 0 0, rgba(31, 145, 199, 0.25), transparent 34%),
    linear-gradient(180deg, var(--brand-950), #082d45);
  box-shadow: 12px 0 36px rgba(7, 43, 66, 0.12);
}

.admin-brand {
  display: flex;
  min-height: 86px;
  padding: 0 20px;
  align-items: center;
  gap: 12px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
}

.admin-brand__mark {
  display: grid;
  width: 42px;
  height: 42px;
  place-items: center;
  border: 1px solid rgba(255, 255, 255, 0.28);
  border-radius: 13px;
  color: var(--accent-300);
  background: rgba(255, 255, 255, 0.08);
  font-family: Georgia, serif;
  font-size: 14px;
  letter-spacing: 0.08em;
}

.admin-brand > div {
  display: flex;
  min-width: 0;
  flex-direction: column;
  gap: 4px;
}

.admin-brand strong {
  font-size: 17px;
  letter-spacing: 0.08em;
}

.admin-brand small {
  color: rgba(255, 255, 255, 0.45);
  font-size: 7px;
  letter-spacing: 0.16em;
}

.admin-brand button {
  display: none;
  margin-left: auto;
  border: 0;
  color: #fff;
  background: transparent;
  font-size: 28px;
}

.admin-menu.el-menu {
  padding: 20px 14px;
  flex: 1;
  overflow-y: auto;
  border-right: 0;
  background: transparent;
}

.admin-menu .el-menu-item {
  height: 50px;
  margin-bottom: 6px;
  border-radius: 12px;
  color: rgba(255, 255, 255, 0.66);
  line-height: 50px;
}

.admin-menu .el-menu-item i {
  color: rgba(255, 255, 255, 0.48);
}

.admin-menu .el-menu-item:hover {
  color: #fff;
  background: rgba(255, 255, 255, 0.08);
}

.admin-menu .el-menu-item.is-active {
  color: #fff;
  background: linear-gradient(90deg, rgba(31, 145, 199, 0.38), rgba(31, 145, 199, 0.14));
  box-shadow: inset 3px 0 0 var(--accent-300);
}

.admin-menu .el-menu-item.is-active i {
  color: var(--accent-300);
}

.admin-aside__foot {
  display: flex;
  padding: 20px 22px 24px;
  flex-direction: column;
  gap: 5px;
  border-top: 1px solid rgba(255, 255, 255, 0.08);
}

.admin-aside__foot span {
  color: rgba(255, 255, 255, 0.52);
  font-size: 9px;
  letter-spacing: 0.18em;
}

.admin-aside__foot small {
  color: rgba(255, 255, 255, 0.35);
  font-size: 11px;
}

.admin-shell__main {
  display: flex;
  width: calc(100% - 248px);
  min-height: 100vh;
  margin-left: 248px;
  flex-direction: column;
}

.admin-shell__header {
  position: sticky;
  top: 0;
  z-index: 50;
  display: flex;
  min-height: 86px;
  padding: 0 clamp(24px, 4vw, 54px);
  align-items: center;
  justify-content: space-between;
  gap: 24px;
  border-bottom: 1px solid rgba(220, 232, 239, 0.88);
  background: rgba(255, 255, 255, 0.92);
  backdrop-filter: blur(16px);
}

.admin-title {
  display: flex;
  align-items: center;
  gap: 14px;
}

.admin-title > div {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.admin-title span {
  color: var(--ink-400);
  font-size: 11px;
  letter-spacing: 0.12em;
}

.admin-title h1 {
  color: var(--ink-950);
  font-size: 22px;
  font-weight: 600;
}

.admin-nav-toggle {
  display: none;
  width: 42px;
  height: 42px;
  border: 1px solid var(--line);
  border-radius: 11px;
  color: var(--brand-700);
  background: var(--brand-50);
}

.admin-actions {
  display: flex;
  align-items: center;
  gap: 10px;
}

.admin-preview,
.admin-logout {
  display: inline-flex;
  min-height: 40px;
  padding: 0 14px;
  align-items: center;
  gap: 7px;
  border: 1px solid var(--line);
  border-radius: 10px;
  color: var(--ink-600);
  background: #fff;
  font-size: 13px;
  text-decoration: none;
  cursor: pointer;
}

.admin-logout {
  border-color: rgba(196, 76, 76, 0.18);
  color: var(--danger);
  background: rgba(196, 76, 76, 0.04);
}

.admin-shell__content {
  width: 100%;
  max-width: 1520px;
  margin: 0 auto;
  padding: clamp(22px, 3vw, 42px);
  flex: 1;
}

.admin-shell__content > div {
  min-height: 100%;
}

.admin-shell__content .el-card,
.admin-shell__content .editor-card {
  border-color: rgba(220, 232, 239, 0.9);
  border-radius: 16px;
  box-shadow: 0 10px 30px rgba(7, 43, 66, 0.07);
}

.admin-shell__content .el-table {
  border-radius: 12px;
  overflow: hidden;
}

.admin-shell__content .el-table th {
  color: var(--ink-600);
  background: #f4f8fb;
}

.admin-shell__content .el-dialog {
  border-radius: 18px;
  overflow: hidden;
}

.admin-shell__footer {
  padding: 18px 30px 26px;
  color: var(--ink-400);
  font-size: 11px;
  text-align: center;
}

.admin-shell__overlay {
  display: none;
}

.avatar-uploader .el-upload {
  position: relative;
  overflow: hidden;
  border: 1px dashed var(--line);
  border-radius: 12px;
  cursor: pointer;
}

.avatar-uploader .el-upload:hover {
  border-color: var(--brand-500);
}

.avatar-uploader-icon {
  width: 178px;
  height: 178px;
  color: var(--ink-400);
  font-size: 28px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  display: block;
  width: 178px;
  height: 178px;
  object-fit: cover;
}

@media (max-width: 900px) {
  .admin-shell__aside {
    width: min(84vw, 300px);
    transform: translateX(-105%);
    transition: transform 0.28s var(--ease-out);
  }

  .admin-shell__aside.is-open {
    transform: translateX(0);
  }

  .admin-brand button,
  .admin-nav-toggle {
    display: block;
  }

  .admin-shell__overlay {
    position: fixed;
    inset: 0;
    z-index: 90;
    display: block;
    visibility: hidden;
    opacity: 0;
    background: rgba(4, 28, 46, 0.55);
    transition: opacity 0.25s ease, visibility 0.25s ease;
  }

  .admin-shell__overlay.is-open {
    visibility: visible;
    opacity: 1;
  }

  .admin-shell__main {
    width: 100%;
    margin-left: 0;
  }
}

@media (max-width: 640px) {
  .admin-shell__header {
    min-height: 72px;
    padding: 0 16px;
  }

  .admin-title span,
  .admin-preview {
    display: none;
  }

  .admin-title h1 {
    font-size: 18px;
  }

  .admin-logout {
    width: 42px;
    padding: 0;
    justify-content: center;
    font-size: 0;
  }

  .admin-logout i {
    font-size: 16px;
  }

  .admin-shell__content {
    padding: 18px 14px 26px;
  }
}
</style>
